import router from './router'
// import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权
// import { getCookie } from '@/utils/support';

// const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  if (!to.name) {
    next({ path: '/home' })
    return
  }
  let pathtype = to.name.substr(0, 3)
  NProgress.start()
  
  // console.log("to---", to)
  // console.log("getToken()---", getToken())
  // console.log("getCookie()---", getCookie())
  // 是否为必须登录状态才能访问的页面
  if (pathtype === 'log' && to.name != 'login') {
    // 验证信息是否过期，过期重新登录
    if (getToken()) {
      next()
    } else if (to.name == 'loghome' && to.query && to.query.token) {    // 来自其他网站并带有用户token
      next()
    } else {
      Message.error('登录信息已过期，请重新登录！')
      setTimeout(() => {
        next({ name: 'login', params: { name: to.name} })
        NProgress.done() // if current page is dashboard will not trigger afterEach hook, so manually handle it
      }, 2000)
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js